module.exports = __webpack_public_path__ + "images/icon_turbo_horizontal_c8c42f934d0664aff34251cc9727fc36.svg";